export function getPassengerCount(adult: number, child: number, infants: number) {
  const parts: string[] = [];
  if (adult > 0) parts.push(`${adult} ${adult === 1 ? "adult" : "adults"}`);
  if (child > 0) parts.push(`${child} ${child === 1 ? "child" : "children"}`);
  if (infants > 0) parts.push(`${infants} ${infants === 1 ? "infant" : "infants"}`);
  return parts.join(", ");
}
